import { getAt } from '@finn-no/mobility-item-insertion-shared';
import { TextArea } from '@warp-ds/react';
import React from 'react';
import { Controller, type FieldError, useFormContext } from 'react-hook-form';
import type { TextAreaWidgetModel } from '../../../types/widget.js';

type TextAreaWidgetProps = Omit<TextAreaWidgetModel, 'type'>;

const TextAreaWidget = React.forwardRef<HTMLTextAreaElement, TextAreaWidgetProps>(({ mandatory, ...rest }, ref) => {
  return <TextArea {...rest} optional={!mandatory} ref={ref} />;
});

// TODO: Move this "Controlled" part out - it seems to be a pattern that is repeated in all widgets
export const ControlledTextAreaWidget = ({ name, helpText, ...props }: TextAreaWidgetProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const error = getAt<FieldError>(errors, name);
  if (error) {
    helpText = (error.message as string) ?? 'Validation error';
  }

  return (
    <div data-attribute={name}>
      <Controller
        name={name}
        data-attribute={name}
        control={control}
        render={({ field }) => (
          <TextAreaWidget
            {...field}
            name={field.name}
            title={props.label}
            helpText={helpText}
            invalid={!!error}
            label={props.label}
            mandatory={props.mandatory}
            rows={5}
          />
        )}
        rules={props.rules}
      />
    </div>
  );
};
